import React, {PureComponent} from 'react';
import {Link} from "react-router-dom";
import {Classes, Overlay} from "@blueprintjs/core";
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from "../../services/httpService";
import toastr from "toastr";
import SubscriptionPlans from "../views/SubscriptionPlans";

export default class UpsellModalTailwind extends PureComponent {
    state = {
        overlayIsOpen: false,
        title: '',
        content: '',
        buttonLabel: '',
        buttonLink: '',
        plan: '',
        planPeriod: true,
        spinnerActiveId: '',
        stripePlans: [],
        selectedPlan: '',
        selectedSource: this.props.selectedSource,
        selectedProject: '',
        chosenPlan: 'boost_yearly',
        chosenPlanFull: '',
        subscribedAt: '',
        clicked: false,
        showUpgradeModal: false,
        remainingMonths: '',
        projects: this.props.user ? this.props.user.sources.data : '',
        user: this.props.user ? this.props.user : '',
        remainingPrice: '',
        remainingPricePerMonth: ''
    }


    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }


    openUpgradeModal = () => {
        this.setState({
            showUpgradeModal: true
        })
    }


    getSelectedPlan = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());
        if (project && project.platforms.length < 1) {
            await this.props.updateUserFromServer()
        }
        if (project && project.platforms.length > 0) {
            //console.log('project: ', project)
            let smsPlatform = await project.platforms.find(platform => platform.platform === 'sms');
            let selectedPlan = await smsPlatform ? smsPlatform.plan : '';
            if (selectedPlan && !this.state.selectedPlan) {
                await this.setState({selectedPlan})
            }
        }
    }

    componentDidMount = async () => {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })


        if ((this.props.user.name === ' ') || !this.props.user.name) {
            await this.props.updateUserFromServer()
        }
        let result = ''
        try {

            result = await http.get('api/emitto_plans/product/emitto_plans', {headers: {authorization: getJwt()}});

            //console.log('stripe plans: ', result)
            await this.setState({stripePlans: result.data.data})
            await this.getSelectedPlan()
            // console.log('get_stripe_plans: ', this.state.stripePlans)
        } catch (e) {
            toastr.error("Couldn't get stripe plans.")
        }

        let chosenPlan = this.state.planPeriod ? 'boost_yearly' : 'boost_monthly'
        let chosenPlanFull = this.state.stripePlans.find(
            stripePlan => {
                return stripePlan.plan_id === chosenPlan
            }
        )
        await this.setState({
            chosenPlan,
            chosenPlanFull,

        })

    }

    componentDidUpdate = async () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal,
                title: this.props.title,
                content: this.props.content,
                plan: this.props.plan
            })
        }
        if (this.state.selectedPlan !== this.props.plan) {
            await this.setState({selectedPlan: this.props.plan})
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({
                selectedSource: this.props.selectedSource
            })
        }
    }


    render() {

        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    // transform: 'scale(0.8)'
                }}
            >
                <span onClick={this.props.handleClose} className='close-upsell-modal'>×</span>
                <div className="modal-field upsell-modal-field"
                     style={{
                         width: this.props.width || '100%',
                         maxWidth: this.props.maxWidth || '100%',
                     }}>

                    <div className="onboarding-panel ">
                        {this.state.title && this.state.title !== '' ?
                            <h2 dangerouslySetInnerHTML={{__html: this.state.title}}
                                className='text-center upsell-title m-lg-b'>

                            </h2>

                            :
                            <h2 className='text-center upsell-title m-lg-b'>
                                This action is not available on your current plan.
                            </h2>
                        }


                        {
                            this.state.content && this.state.content !== ''
                                ?
                                <p dangerouslySetInnerHTML={{__html: this.state.content}}
                                   className='m-lg-b text-center'>

                                </p> :
                                <p className='text-center m-lg-b '>
                                    Check out the plans and features below and choose the one that suits your needs.
                                    Our team is available from the chat if you need any assistance
                                </p>
                        }
                        <SubscriptionPlans
                            user={this.state.user}
                            selectedSource={this.state.selectedSource}
                            history={this.props.history}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                </div>
            </Overlay>
        )
    }
}